import React, { Fragment, useContext } from "react";
import { Form, Radio } from "antd";
import { Title } from "./Common";
import MapPropsContext from "../MapPropsContext";
import { StyledButton } from "../../../styled-components/Button";
import {
  TI_SEARCH_RADIUS_1000,
  TI_SEARCH_RADIUS_500,
} from "../../../Constants";

function WidgetVisibleRadius() {
  const {
    widgetState: { visible_radius },
    onChangeWidgetState,
  } = useContext(MapPropsContext);

  return (
    <Fragment>
      <Title>검색반경</Title>
      <div style={{ display: "flex" }}>
        <StyledButton
          style={{ flex: 1 }}
          isActive={visible_radius === 500}
          onClick={() => {
            onChangeWidgetState({
              target: {
                value: 500,
                type: "radio",
                checked: true,
                className: "",
                defaultChecked: false,
                disabled: undefined,
                name: "visible_radius",
              },
            });
          }}
          tabIndex={TI_SEARCH_RADIUS_500}
          borderRadius="4px 0px 0px 4px"
        >
          500m
        </StyledButton>
        <StyledButton
          style={{ flex: 1 }}
          isActive={visible_radius === 1000}
          onClick={() => {
            onChangeWidgetState({
              target: {
                value: 1000,
                type: "radio",
                checked: true,
                className: "",
                defaultChecked: false,
                disabled: undefined,
                name: "visible_radius",
              },
            });
          }}
          tabIndex={TI_SEARCH_RADIUS_1000}
          borderRadius="0px 4px 4px 0px"
        >
          1km
        </StyledButton>
      </div>
      {/* <Radio.Group
        name="visible_radius"
        value={visible_radius}
        onChange={(e) => {
          console.log(e);
          onChangeWidgetState(e);
        }}
        buttonStyle="solid"
        size="small"
        style={{ display: "flex" }}
      >
        <Radio.Button value={500} style={BUTTON_STYLE}>
          500m
        </Radio.Button>
        <Radio.Button value={1000} style={BUTTON_STYLE}>
          1km
        </Radio.Button>
      </Radio.Group> */}
    </Fragment>
  );
}

const BUTTON_STYLE = {
  flex: 1,
  textAlign: "center",
};

export default WidgetVisibleRadius;
